document.addEventListener('DOMContentLoaded', function () {
  // Desktop Mega Menu Carousels
  const desktopCarousels = document.querySelectorAll('.mega-menu-carousel-wrapper');
  
  desktopCarousels.forEach((carouselWrapper) => {
    const swiperContainer = carouselWrapper.querySelector('.swiper-container');
    const nextBtn = carouselWrapper.querySelector('.my-swiper-button-next');
    const prevBtn = carouselWrapper.querySelector('.my-swiper-button-prev');
    const paginationEl = carouselWrapper.querySelector('.swiper-pagination');
    
    if (swiperContainer && typeof Swiper !== 'undefined') {
      new Swiper(swiperContainer, {
        slidesPerView: 2,
        spaceBetween: 12,
        loop: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 12
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 12
          }
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        }
      });
    }
  });

  // Mobile Drawer Menu Carousels
  const mobileCarousels = document.querySelectorAll('.mobile-menu-carousel-wrapper');
  
  mobileCarousels.forEach((carouselWrapper) => {
    const swiperContainer = carouselWrapper.querySelector('.swiper-container');
    const paginationEl = carouselWrapper.querySelector('.swiper-pagination');
    
    if (swiperContainer && typeof Swiper !== 'undefined') {
      new Swiper(swiperContainer, {
        slidesPerView: 2,
        spaceBetween: 8,
        loop: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        }
      });
    }
  });
});

